export default __webpack_public_path__ + "static/media/print_estimate_shanai_3.53f5d025.svg";